import { t } from "i18next";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { convertToEuro } from "../../utils/utility";

const BuyTicketPriceCard = ({
  setPriceType,
  setPriceId,
  setPriceAmount,
  priceType,
  priceId,
  checkEmptyInput,
  setTicketName,
  setPriceTwoWay,
}) => {
  const [selectedPriceId, setSelectedPriceId] = useState(null);
  const { schedules, schedulesId } = useSelector(
    (state) => state.schedulesReducer
  );
  const { showEuroPrice, selectedLanguage } = useSelector(
    (state) => state.mainReducer
  );
  const { showTwoWayDateInput } = useSelector(
    (state) => state.destinationReducer
  );

  const getExactSchedule = schedules?.find(
    (schedule) => schedule?.kursId === schedulesId
  );

  const selectTicket = (typeId) => {
    if (typeId !== selectedPriceId) {
      setSelectedPriceId(typeId);
    }
  };

  useEffect(() => {
    if (getExactSchedule?.price?.length === 1) {
      const price = getExactSchedule.price[0];
      setPriceId(price.id);
      setPriceType(price.typeId);
      selectTicket(price.typeId);
      setPriceAmount(price.price);
      setTicketName(price.name);
      setPriceTwoWay(price.priceTwoWay);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getExactSchedule]);

  return (
    <div>
      <p className="buy-ticket-price-card-ticket-heading remove-pointer-events">
        {t("ticket")}
      </p>
      <div className="buy-ticket-price-card-container">
        {getExactSchedule?.price
          ?.filter(
            (price) => !(showTwoWayDateInput && price.priceTwoWay == null)
          )
          .map((price) => {
            return (
              <div
                className={`buy-ticket-price-card ${
                  !priceId &&
                  !priceType &&
                  checkEmptyInput &&
                  "empty-tickets-and-seats"
                } ${
                  selectedPriceId === price.typeId
                    ? "buy-ticket-price-card-selected-ticket"
                    : ""
                }`}
                key={price.typeId}
                onClick={() => {
                  setPriceId(price.id);
                  setPriceType(price.typeId);
                  selectTicket(price.typeId);
                  setPriceAmount(price.price);
                  setTicketName(price.name);
                  setPriceTwoWay(price.priceTwoWay);
                }}
              >
                <div className="buy-ticket-price-card-heading remove-pointer-events">
                  {showTwoWayDateInput ? (
                    <>
                      <p>{t("twoWay")}</p>
                      <p style={{ opacity: "0.7", fontSize: "14px" }}>
                        {selectedLanguage === "bg" ? price.name : ""}
                      </p>
                    </>
                  ) : price.name === "Редовен" && selectedLanguage === "en" ? (
                    "Regular"
                  ) : (
                    price.name
                  )}
                </div>
                <div>
                  <p className="buy-ticket-price-card-price remove-pointer-events">
                    {showTwoWayDateInput
                      ? price.priceTwoWay.toFixed(2)
                      : price.price.toFixed(2)}{" "}
                    <span style={{ fontSize: "15px" }}>€</span>
                  </p>
                  {showEuroPrice && (
                    <p className="buy-ticket-price-card-price remove-pointer-events">
                      {showTwoWayDateInput
                        ? convertToEuro(price?.priceTwoWay)?.toFixed(2)
                        : convertToEuro(price?.price)?.toFixed(2)}{" "}
                      <span style={{ fontSize: "15px" }}>{t("lv")}</span>
                    </p>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default BuyTicketPriceCard;
